import styled from "styled-components";
import { color } from "@m/alchemy-theme";
import { Flex } from "../flex/Flex";
import { IS_END_OF_ROW_CLASS_NAME } from "../hooks/useTagRowWraps";
export const ToolbarGroup = styled(Flex).attrs((props) => ({
    wrap: "wrap",
    gap: props.gap || "inherit"
})) `
  &::after {
    content: " ";
    height: 20px;
    width: 1px;
    margin: 0 4px;
    background-color: ${color("inputBorder", { opacity: 0.75 })};
  }

  &.${IS_END_OF_ROW_CLASS_NAME}:after {
    /* It's important not to change layout, 
    which can trigger an infinite reflow loop here. 
    So no "display: none" here please! */
    visibility: hidden;
  }

  &:last-of-type:after {
    display: none;
  }
`;
